import Svg, { Path, type PathProps, type SvgProps } from 'react-native-svg'
import { mesaColorNames } from '@/src/common/theme'

export function BankOutlined({
  svgProps,
  pathProps,
}: {
  svgProps?: SvgProps
  pathProps?: PathProps
}) {
  return (
    <Svg
      viewBox="0 0 24 24"
      width={svgProps?.width ?? 24}
      height={svgProps?.height ?? 24}
      fill="none"
      {...svgProps}
    >
      <Path
        d="M12.5 7.49997C12.5 7.77611 12.2761 7.99997 12 7.99997C11.7239 7.99997 11.5 7.77611 11.5 7.49997C11.5 7.22383 11.7239 6.99997 12 6.99997C12.2761 6.99997 12.5 7.22383 12.5 7.49997Z"
        fill="white"
      />
      <Path
        d="M18 11H6M18 11C19.1046 11 20 10.1045 20 8.99997V8.38597C20 7.55228 19.4829 6.80604 18.7022 6.51331L13.4045 4.52666C12.499 4.18708 11.501 4.18708 10.5955 4.52666L5.29775 6.51331C4.51715 6.80604 4 7.55228 4 8.38597V8.99997C4 10.1045 4.89543 11 6 11M18 11H14V17H18V11ZM6 11H10V17H6V11ZM5.38743 20H18.6126C19.2951 20 19.7771 19.3313 19.5613 18.6837L19.2279 17.6837C19.0918 17.2754 18.7097 17 18.2792 17H5.72076C5.29033 17 4.90819 17.2754 4.77208 17.6837L4.43874 18.6837C4.2229 19.3313 4.70487 20 5.38743 20ZM12.5 7.49997C12.5 7.77611 12.2761 7.99997 12 7.99997C11.7239 7.99997 11.5 7.77611 11.5 7.49997C11.5 7.22383 11.7239 6.99997 12 6.99997C12.2761 6.99997 12.5 7.22383 12.5 7.49997Z"
        stroke={mesaColorNames['Acre Turquoise/500 #00DFC9']}
        strokeWidth="1.5"
        strokeLinejoin="round"
        {...pathProps}
      />
    </Svg>
  )
}
